const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjecte = async (projecte: any, id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: projecte.id,
                nom: projecte.nom,
                id_usuari: id,
                descripcio: projecte.descripcio,
                estat: projecte.estat,
                data_ini: projecte.data_ini,
                data_fi: projecte.data_fi,
                id_aula: projecte.id_aula,
                id_aules: projecte.id_aules,
                escala_validacio: projecte.escala_validacio,
                img: projecte.img

            })
        });
        if (!response.ok && response.status !== 201) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
